import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-icon-information',
  templateUrl: './icon-information.component.html',
  styleUrls: ['./icon-information.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IconInformationComponent {
  @Input() icon: any;
  @Input() title: any;
  @Input() subtitle: any;
}
